import { Typography } from "@mui/material";
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ReferenceLine, XAxis, YAxis } from "recharts";
import _ from 'lodash'
import { getClient } from "entity/LaudoVisita/components/LaudoVisitaConsultaRelatorios/functions";

export default function LBMGraficoExtraPainel({ indicadorProps, nomeAgrupador }) {
    let grupo = indicadorProps.mediaAgrupadorList[0]

    // obtém média de Brocas Internas e verifica o status p/ gerar a barra do gráfico
    let mediaBrocasInternas = _.meanBy(grupo.apontamentos, (a) => parseFloat(_.get(a, 'percentBrocasInternas', 0)))
    grupo.mediaBrocasInternas = mediaBrocasInternas.toFixed(2) // conformidade Brocas Internas
    if (indicadorProps.paramsCliente) { // status e cor Brocas Internas
        // pega os parametros do cliente do primeiro laudo retornado pelo BD
        let auxCliente = indicadorProps.apontamentos && indicadorProps.apontamentos.length && indicadorProps.apontamentos[0].laudoRef && indicadorProps.apontamentos[0].laudoRef.cliente ? indicadorProps.apontamentos[0].laudoRef.cliente : indicadorProps.paramsCliente
        grupo.statusBrocasInternas = indicadorProps.IndicadorClass.constructor.getConformidadeStatus(mediaBrocasInternas, indicadorProps.paramsCliente.metaBrocasInternas, null, getClient(auxCliente))
        grupo.colorBrocasInternas = indicadorProps.IndicadorClass.constructor.getColorStatus(grupo.statusBrocasInternas)
    }

    return (
        <>
            <BarChart
                width={450}
                height={350}
                data={
                    indicadorProps.mediaAgrupadorList.map(barra => (
                        {
                            name: barra.groupNameShow, // texto abaixo da barra do gráfico
                            valor: barra.mediaBrocasInternas
                        }
                    ))
                }
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis
                    // altura do gráfico de zero até a (maior média + 5 porcento dela), isso deixa o gráfico um pouco maior que a maior barra
                    domain={[
                        0,
                        (Math.max(...indicadorProps.mediaAgrupadorList.map(item => item.mediaBrocasInternas)) + Math.max(...indicadorProps.mediaAgrupadorList.map(item => item.mediaBrocasInternas)) * 0.05)
                    ]}
                />
                <ReferenceLine
                    // linha pontilhada marcando a meta
                    y={indicadorProps.paramsCliente?.metaBrocasInternas}
                    stroke="blue"
                    strokeDasharray="3 3"
                    label={{ value: '', position: 'left' }}
                />
                <Bar dataKey="valor" radius={[10, 10, 0, 0]}>
                    {indicadorProps.mediaAgrupadorList.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.colorBrocasInternas} />)}
                    <LabelList
                        dataKey="valor"
                        position='top'
                        fill="#000"
                        fontWeight="bold"
                    />
                </Bar>
            </BarChart>
            {
                indicadorProps && indicadorProps.paramsCliente && indicadorProps.paramsCliente.metaBrocasInternas
                    ? (
                        <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'subtitle1'}>
                            Meta Brocas Internas: {indicadorProps.paramsCliente.metaBrocasInternas}
                        </Typography>
                    )
                    : <></>
            }
            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'caption'}>por {nomeAgrupador}</Typography>
        </>
    )
}